import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState, Flex, Text } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/chatUtils';
import { PanelDetails, PanelTable } from '../styles';

export function DriversPanel({ driver }) {
  const getPhones = () => {
    const phones = [];
    const phoneFieldDomains = {
      0: 'phoneType.workPhone',
      1: 'phoneType.homePhone',
      3: 'phoneType.cellularPhone',
      4: 'phoneType.fax'
    };

    if (driver?.phone1) {
      phones.push({
        type: getResourceTo(phoneFieldDomains[driver?.phone1Type]),
        number: driver?.phone1
      });
    }

    if (driver?.phone2) {
      phones.push({
        type: getResourceTo(phoneFieldDomains[driver?.phone2Type]),
        number: driver?.phone2
      });
    }

    return phones;
  };

  const phones = getPhones();

  if (!driver) {
    return <EmptyState />;
  }

  return (
    <>
      <PanelDetails>
        <Flex justifyContent="space-between" alignItems="center">
          <Text>
            <strong>
              {driver?.key} - {driver?.name}
            </strong>
          </Text>
        </Flex>
      </PanelDetails>
      <PanelTable>
        <table>
          <tbody>
            {phones.map(({ type, number }) => (
              <tr key={type}>
                <td>{type}</td>
                <td>{number}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </PanelTable>
    </>
  );
}

DriversPanel.propTypes = {
  driver: PropTypes.object
};
